export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/sync.worker.1c829e90.worker.js");
}
